var _a;
import { __awaiter } from "tslib";
class PromiseQueue {
    constructor() {
        this.queue = [];
        this.top = 0;
    }
    // Randomly pick a task from one of promise queue
    // lager size queue has more chance to be picked
    static roll(...queues) {
        const totalSize = queues.reduce((sum, queue) => sum + queue.size(), 0);
        const random = Math.random() * totalSize;
        let current = 0;
        for (const queue of queues) {
            current += queue.size();
            if (random < current) {
                return queue.next();
            }
        }
        return Promise.resolve();
    }
    size() {
        return this.queue.length - this.top;
    }
    isEmpty() {
        const isEmpty = this.size() === 0;
        if (isEmpty) {
            this.reset();
        }
        return isEmpty;
    }
    next() {
        if (this.top < this.queue.length) {
            const task = this.queue[this.top];
            this.top += 1;
            return task().catch(() => { });
        }
        return Promise.resolve();
    }
    push(task) {
        this.queue.push(task);
    }
    reset() {
        this.queue = [];
        this.top = 0;
    }
}
/**
 * 移动端本地编辑 fetch 和 Canvas.toBlob 并行执行会相互干扰，会造成页渲染大幅推迟，
 * 这里通过修改 Canvas.toBlob 的实现，将 toBlob 和 fetch 的调用顺序改为串行执行，解决这个问题。
 */
export class EvilPatchCanvasDOMToBlob {
    static patch() {
        if (this.state !== 'unpatched') {
            return () => { };
        }
        const { toBlobQueue, resume } = this;
        const originalToBlob = HTMLCanvasElement.prototype.toBlob;
        this.state = 'paused';
        HTMLCanvasElement.prototype.toBlob = function (callback, type, quality) {
            toBlobQueue.push(() => {
                return new Promise((resolve) => {
                    originalToBlob.call(this, (blob) => {
                        try {
                            callback(blob);
                        }
                        finally {
                            resolve();
                        }
                    }, type, quality);
                });
            });
            resume().catch(() => { });
        };
        return () => {
            HTMLCanvasElement.prototype.toBlob = originalToBlob;
            this.resume().finally(() => {
                this.toBlobQueue.reset();
                this.conflictTaskQueue.reset();
                this.state = 'unpatched';
            });
        };
    }
    static addConflictTask(task) {
        if (this.state === 'unpatched') {
            return task();
        }
        return new Promise((resolve, reject) => {
            this.conflictTaskQueue.push(() => task()
                .then(resolve)
                .catch(reject)
                .catch(() => { }));
            this.resume().catch(() => { });
        });
    }
    static next() {
        /**
         * 随机从两个队列中取一个任务执行，这样可以保证两个队列的任务都能被执行到，防止其中一个队列的任务一直被阻塞
         */
        return PromiseQueue.roll(this.toBlobQueue, this.conflictTaskQueue);
    }
}
_a = EvilPatchCanvasDOMToBlob;
/**
 * toBlob 任务队列
 */
EvilPatchCanvasDOMToBlob.toBlobQueue = new PromiseQueue();
/**
 * 和 toBlob 存在冲突的任务队列
 */
EvilPatchCanvasDOMToBlob.conflictTaskQueue = new PromiseQueue();
EvilPatchCanvasDOMToBlob.state = 'unpatched';
EvilPatchCanvasDOMToBlob.resume = () => __awaiter(void 0, void 0, void 0, function* () {
    if (_a.state === 'running' || _a.state === 'unpatched') {
        return;
    }
    _a.state = 'running';
    while (!_a.toBlobQueue.isEmpty() || !_a.conflictTaskQueue.isEmpty()) {
        yield _a.next();
    }
    _a.state = 'paused';
});
//# sourceMappingURL=evil-patch-canvas-dom-to-blob.js.map